/* lua.js generated code 0.3.0 */

Toast = table()
var _toastContainer = null
let _buyBanRegex = null
Toast.make = function (text, displayTime, callback, clickClose, displayPosY, internalCall) {
    var scene = cc.Director.getInstance().getRunningScene()
    displayTime = displayTime || 1.2
    if (text && window.SnsProxy && SnsProxy.getInstance().isBuyBan()) {
        if (_buyBanRegex == null) {
            _buyBanRegex = new RegExp(getText("buy.out.buyban"), "g")
        }
        text = text.replace(_buyBanRegex, getText("buy.in.buyban"))
    }
    if (cc.sys.platform === cc.sys.WECHAT_GAME && (!scene || scene.name === 'PreloadScene' || scene.name === 'LevelLoadingScene')) {
        mini.showToast({
            title: text,
            icon: 'none',
            duration: (displayTime + 1.8) * 1000,
        })
        return
    }
    if (!internalCall && global.mini &&mini.getPlatform() == MiniPlatform.oppoQuickgame) {
        // oppo 离屏后文字显示有问题，暂时setTimeout处理一下
        setTimeout(()=> Toast.make(text, displayTime, callback, clickClose, displayPosY, true), 200)
        return;
    }
    FrameLoader.loadImageWithPlist("cocos/uilibrary.plist")
    var container = cc.Node.create()
    var bg
    if (cc.spriteFrameCache.getSpriteFrame("uilibrary/toast_bg.png")) {
        bg = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/toast_bg.png", cc.rect(34, 35, 30, 23))
    } else{
        bg = cc.LayerColor.create(cc.c4b(255,219,154,255))
        bg.changeWidthAndHeight(150,100)
        bg.setAnchorPoint(cc.p(0.5, 0.5))
        bg.ignoreAnchor = false
    }
    var lb = cc.Label.createWithSystemFont(text, null, 26)
    lb.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    //TODO:绕过华为机型toast错误
    if (!window.qq)
        lb.setDimensions(display.width / 2, 0)
    container.addChild(bg)
    container.addChild(lb)
    var width = lb.getBoundingBox().width * 1.2
    lb.setTextColor(cc.c4b(138, 77, 20, 255))
    var size = bg.getContentSize()
    bg.setContentSize(cc.size(Math.max(width, 206), size.height * 1.2))
    lb.setAnchorPoint(cc.p(0.5, 0.5))
    lb.boundingWidth = width;//设置下boundingWidth 防止被动换行
    container.setPosition(display.center.x, displayPosY || display.center.y)
    if (scene != null) {
        scene.addChild(container, 9999999)
        if (clickClose) {
            var touchBlock = cc.Sprite.create()
            var vSize = cc.Director.getInstance().getVisibleSize()
            touchBlock.setContentSize(cc.size(vSize.width + 200, vSize.height + 200))
            touchBlock.onClicked(function () {
                if (container) {
                    container.removeFromParent(true)
                    _toastContainer = null
                    if (callback && type(callback) === "function") {
                        callback()
                    }
                }
            })
            container.addChild(touchBlock)
        }
        container.runAction(cc.Sequence.create(table(
            [0, cc.Spawn.create(table([0, cc.FadeIn.create(0.1)], [0, cc.MoveBy.create(0.4, cc.p(0, 100))]))],
            [0, cc.DelayTime.create(displayTime)],
            [0, cc.FadeOut.create(0.3)],
            [0, cc.CallFunc.create(function () {
                if (container) {
                    container.removeFromParent(true)
                    _toastContainer = null
                    if (callback && type(callback) === "function") {
                        callback()
                    }
                }
            })]
        )))
        _toastContainer = container
    }else {
        alert(text)
        if (callback && type(callback) === "function") {
            callback()
        }
    }
}
Toast.clearToast = function () {
    var self = this
    if (_toastContainer) {
        _toastContainer.removeFromParent(true)
        _toastContainer = null
    }
}
